<div
  class="aspect-square relative cursor-pointer bg-theme-gray-three rounded-xl"
  (click)="openImage()"
>
  <img
    *ngIf="currentlyDisplayedList"
    [src]="currentlyDisplayedList[index].name"
    class="h-full w-full object-cover object-center rounded-xl border-2 border-site-main-one"
  />

  <div
    class="bg-white px-4 py-1 absolute -top-5 right-8 text-12 font-bold text-site-main-one rounded truncate max-w-[calc(100%-60px)] shadow"
    *ngIf="currentlyDisplayedList"
  >
    {{ currentlyDisplayedList[index].course.displayNumber }} :
    {{ currentlyDisplayedList[index].course.title }}
  </div>
</div>
